import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/Core/interceptors/http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  constructor(private http: HttpClient, private httpService: HttpService) {}
  getBlogs(page: number, per_page: number, options = {}, search?: string): Observable<any> {
    const requestOptions = {
      ...options,
    };
    let url = `${environment.wordpressUrl}wp-json/api/v1/posts?per_page=${per_page}&page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return this.http.get(url, requestOptions);
  }
  getBlogImage(imageId: number): Observable<any> {
    return this.http.get(
      `${environment.wordpressUrl}wp-json/wp/v2/media/${imageId}`
    );
  }
  getBlogDetails(slug: string): Observable<any> {
    return this.http.get(
      `${environment.wordpressUrl}wp-json/api/v1/post/${encodeURIComponent(slug)}`
    );
  }
  getHomeData(): Observable<any> {
    return this.httpService.get(`${environment.url}/buyer/home`);
  }
  getHomepageBootstrap(params: {
    locale?: string;
    page?: number;
    per_page?: number;
    search_term?: string;
    blogs_search?: string;
  } = {}): Observable<any> {
    return this.httpService.getWithParams(
      `${environment.url}/main-website-general/homepage/bootstrap`,
      params
    );
  }
  getSearchItems(params: {
    page_size: number;
    page: number;
    search_term: string;
  }): Observable<any> {
    return this.httpService.getWithParams(
      `${environment.url}/items/search`,
      params
    );
  }
  contactUs(body: {
    name: string;
    message: string;
    phone: number;
    email: string;
  }): Observable<any> {
    return this.httpService.post(`${environment.url}/contactUs`, body);
  }
}
